module.exports = __webpack_public_path__ + "img/warehouse.baafa31d.png";